module.exports = __webpack_public_path__ + "static/media/view_selection.c3bd9908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LivestockIdxTool/view_selection.png
// module id = 1787
// module chunks = 0